export const transportationVehicleTypes = [
  { value: 1, label: 'Car' },
  { value: 2, label: 'Bus' },
]

export const providers = [
  { value: 1, label: 'Frotcom' },
  { value: 2, label: 'Almaks' },
  { value: 3, label: 'Develon' },
]
